<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
          <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
              <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
              <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
              </nav>
            </b-col>
          </b-row>
        </base-header>
        <b-container fluid class="mt--6">
          <div>
              <loading :active ="progressCounter > 0" 
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true" 
                :is-full-page="fullPage">
              </loading>
          </div>
          <b-row>
            <b-col lg="12">
              <div class="card-wrapper">
                <card>
                  <b-row>
                    <b-col cols="12" class="mt--4 ml--3">
                        <b-tabs pills card>
                            <b-tab title="Vendor + Product" @click="clickOnReportSubType('Vendor + Product')">
                            </b-tab>
                            <b-tab title="Product Category + Product" @click="clickOnReportSubType('Product Category + Product')">
                            </b-tab>
                        </b-tabs>
                    </b-col>          
                  </b-row>
                  <b-row class="mt--4" v-if="reportSubType=='Vendor + Product'">
                    <b-col md="4" >
                      <label class="form-control-label">{{
                      language_terms["VENDOR"]}}</label>
                      <multiselect
                        :internalSearch = "false"
                        v-model="vendor"
                        id="ajax"
                        label="name"
                        track-by="id"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :options="vendors"
                        :multiple="false"
                        :searchable="true"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="300"
                        :limit="50"
                        :max-height="600"
                        :show-no-results="false"
                        :hide-selected="false"
                        @search-change="asyncFindVendor"
                        @input="onSelectVendor"
                      >
                      </multiselect>
                    </b-col>
                    <b-col md="5">
                          <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                          <productLookup v-bind:url="apiProductLookup" v-on:selected="selectProduct($event)" :lookupId="item.product_code"/>
                    </b-col>
                    <b-col md="1" >
                      <base-input :label="language_terms['DATE_FROM']">
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white;"
                                    class="form-control datepicker"
                                    v-model="date_from">
                        </flat-picker>
                      </base-input>
                    </b-col>
                    <b-col md="1">
                      <base-input :label="language_terms['DATE_TO']">
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white;"
                                    class="form-control datepicker"
                                    v-model="date_to">
                        </flat-picker>
                      </base-input>
                    </b-col>
                    <b-col cols="1" class="mt-4">
                      <base-button type="primary" @click="clickOnGenerate" class="mt-2 mr-4" :disabled="vendor==null && product_id==null">{{language_terms['RUN']}}</base-button>
                    </b-col>
                  </b-row>
                  <b-row class="mt--4" v-if="reportSubType=='Product Category + Product'">
                    <b-col md="3">
                        <label class="form-control-label">{{language_terms['PRODUCT_CATEGORY']}}</label>
                        <productLookup v-bind:url="apiProductCategoriesLookup"  v-on:selected="selectProductCategories($event)" :lookupId="item.product_code"/>
                    </b-col>
                    <b-col md="3">
                        <label class="form-control-label">{{language_terms['PRODUCT'] + ' From'}}</label> 
                        <el-select v-model="product_from" class="w-100">
                          <el-option
                          v-for="product in products"
                          :key = "product.code"
                          :label= "product.name"
                          :value="product.row_num"
                          >
                          </el-option>
                        </el-select>
                    </b-col>
                    <b-col md="3">
                        <label class="form-control-label">{{language_terms['PRODUCT'] + ' To'}}</label>
                        <el-select v-model="product_to" class="w-100">
                          <el-option
                          v-for="product in products"
                          :key = "product.code"
                          :label= "product.name"
                          :value="product.row_num"
                          >
                          </el-option>
                        </el-select>
                    </b-col>
                    <b-col md="1" >
                      <base-input :label="language_terms['DATE_FROM']">
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white;"
                                    class="form-control datepicker"
                                    v-model="date_from">
                        </flat-picker>
                      </base-input>
                    </b-col>
                    <b-col md="1">
                      <base-input :label="language_terms['DATE_TO']">
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white;"
                                    class="form-control datepicker"
                                    v-model="date_to">
                        </flat-picker>
                      </base-input>
                    </b-col>
                    <b-col md="4" >
                      <label class="form-control-label">{{
                      language_terms["VENDOR"]}}</label>
                      <multiselect
                        :internalSearch = "false"
                        v-model="vendor"
                        id="ajax"
                        label="name"
                        track-by="id"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :options="vendors"
                        :multiple="false"
                        :searchable="true"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="300"
                        :limit="50"
                        :max-height="600"
                        :show-no-results="false"
                        :hide-selected="false"
                        @search-change="asyncFindVendor"
                        @input="onSelectVendor"
                      >
                      </multiselect>
                    </b-col>
                    <b-col cols="1" class="mt-4">
                      <base-button type="primary" @click="clickOnGenerate" class="mt-2 mr-4" :disabled = "product_from == null || product_to==null||productcategory_id==null">{{language_terms['RUN']}}</base-button> 
                    </b-col>
                  </b-row>
                </card>
                <v-client-table v-if="report.rows.length > 0" v-model="report.rows" :columns="report.headers" :options="reportOptions" @row-click="onClickInvoice">
                  <template slot="Item Description" slot-scope="{ row }">
                      <span v-html="formatProductDescription(row['Item Description'])"></span>
                  </template>
                </v-client-table>
              </div>
            </b-col>
          </b-row>
          <b-modal id="modalInvoice" v-model="modalInvoice" size="xl" centered class="my-modal" hide-footer>
              <template>
                  <div v-if="modalInvoice">
                      <b-row class="align-items-center mt--2">
                          <b-col md="12" fluid class="mt--7">
                              <h6 class="h2">{{language_terms["INVOICE"]}}</h6>
                          </b-col>
                      </b-row>
                      <b-row>
                          <b-col lg="6" md="6">
                              <base-input :label="language_terms['INV_#']" :value="invoice.master.code" disabled></base-input>
                          </b-col>
                          <b-col lg="6" md="6">
                              <base-input :label="language_terms['CUSTOMER']" :value="invoice.master.customer_name" disabled></base-input>
                          </b-col>
                          <b-col lg="4" md="6">
                              <base-input :label="language_terms['DATE']" :value="invoice.master.date" disabled></base-input>
                          </b-col>
                          <b-col lg="4" md="6">
                              <base-input :label="language_terms['SALESPERSON']" :value="invoice.master.salesperson_name" disabled></base-input>
                          </b-col>
                          <b-col lg="4" md="6">
                              <base-input :label="language_terms['TYPE']" :value="invoice.master.type" disabled></base-input>
                          </b-col>
                          <b-col lg="12">
                              <base-input label="Remarks"><textarea disabled class="form-control" id="exampleFormControlTextarea1" rows="3" :value="invoice.master.remarks"></textarea>
                              </base-input>
                          </b-col>
                      </b-row>
                      <b-row v-if="invoice.details.rows.length > 0">
                          <b-col cols="12">
                              <v-client-table v-model="invoice.details.rows" :columns="invoice.details.columns" :options="reportOptions"  >
                              </v-client-table>
                          </b-col>
                      </b-row>
                  </div>
              </template>
          </b-modal>          
        </b-container>
    </div>
  </template>
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  <style>
  th.VueTables__sortable {
      color:rgb(255,255,255);
  }
  td.VueTables__row  {
      color:black
  }
  .v-data-table /deep/ .sticky-header {
    position: sticky;
    top: var(--toolbarHeight);
  }
  
  .v-data-table /deep/ .v-data-table__wrapper {
    overflow: unset;
  }
  </style>
  <script>
  import productLookup from "@/components/Autocomplete.vue";
  import moment from 'moment'
  import { Select, Option,Table, TableColumn, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';  
  import { mapState } from "vuex";
  import PaginatedTables from '@/views/Tables/PaginatedTables'
  import axios from "axios";
  import { apiRoutes } from "../../apiRoutes";
  import { authHeader } from "../../global";
  import { exit } from "process";
  
  export default {
    components:{
      productLookup,
      Loading,
      [Select.name]: Select,
      [Option.name]: Option,
      flatPicker,
      PaginatedTables
    },
    computed: {
      ...mapState({
          language_terms: (state) => state.languages.language_terms,
          selected_lang: (state) => state.languages.selected_langauge,
      })
    },  
    async mounted()
    {
      this.date_from = moment().subtract(12, 'months').format('YYYY-MM-DD');
      this.date_to = moment().format("YYYY-MM-DD")
      this.reportSubType = 'Vendor + Product'
    },
    data(){
      return{
        modalInvoice:false,
        product_from:null,
        product_to:null,
        reportSubType:'',
        item:[],
        apiProductLookup: apiRoutes["PRODUCT_LOOKUP"],
        apiProductCategoriesLookup: apiRoutes["PRODUCT_CATEGORIES_LOOKUP"],
        apiReportsSalesLookupProductPerCat: apiRoutes["REPORTS_SALES_LOOKUP_PRODUCT_PER_CAT"],
        productcategory_id:null,
        product_id:null,
        //customer_id:null,
        vendors:[],
        products:[],
        vendor:null,
        contact_name:null,
        date_from:null,
        date_to:null,
        fullPage:true,
        progressCounter:0,
        reportOptions:{perPage:10000, perPageValues:[],stickyHeader:true, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C',
        hiddenColumns:['id','vendor_id','invoice_date','vendor_code','Exch Rate'],filterable:false},
        report:{headers:[], rows:[]},
      }
    },
  
    methods:{
      formatProductDescription(description) {
            // Replace newline characters (\n) with HTML line breaks
            return description.replace(/\n/g, '<br>');
      },
      async onClickInvoice(option)
      {
        let payload = {document_code:option.row['Doc #']}
        await axios.post(apiRoutes['CLIENT_RETRIEVE_PURCHASE_INVOICE'],payload, authHeader()).then((response)=>
        {
            if (response.data.code == 1)
            {
                this.invoice = response.data.data
                this.modalInvoice = true
            }
            else
            {
                this.invoice = null;
            }
        }
        )
        .catch((error)=> {
            if(error.response)
            {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            }
        });
      },      
      clickOnReportSubType(type)
      {
        this.reportSubType = type
        //clean up
        this.report={headers:[], rows:[]};
        this.product_from=null;
        this.product_to=null;
        this.vendor=null;
      },
      async selectProduct(product)
      {
          this.product_id = product.id
      },  
       async selectProductCategories(product)
      {
          this.progressCounter++;
          this.productcategory_id = product.id
          
          //send the prodcategoryid to the backend api to return product list within categories
          let payload = {prodcategoryid: this.productcategory_id};
          await axios.post(apiRoutes['REPORTS_PURCHASE_LOOKUP_PRODUCT_PER_CAT'],payload, authHeader()).then((response)=>
          {
            if (response.data.code==1)
            {
              this.products=response.data.data;
            }
            else
            {
              this.products=[];
            }
  
          })
          .catch((error)=> {
            if(error.response)
            {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            }else {
              alert('Application/Network error');
            }
          });

          this.progressCounter--;
      },   
      async onSelectVendor(selectedOption) {
        this.vendor = selectedOption
      },    
      async asyncFindVendor(query) 
      {
        this.progressCounter++
  
        let pv = { value: query };
        await axios.post(apiRoutes["VENDOR_LOOKUP"], pv, authHeader()).then((response) => {
            if (response.data.code == 1) {
              this.vendors = response.data.data;
            } else {
              this.vendors = [];
            }
  
            this.progressCounter--;
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response);
              Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
              });
            } else {
              console.log("Problem submitting New Post", error);
            }
          });
      },
      updateTableLang(){
        if(this.type != 'DO')
        {
          for(let i=0; i < this.tableColumns.length;i++)
          {
            let key = this.tableColumns[i].key
            this.tableColumns[i].label = this.language_terms[key]
          }
        }
        else
        {
          for(let i=0; i < this.do_tableColumns.length;i++)
          {
            let key = this.do_tableColumns[i].key
            this.do_tableColumns[i].label = this.language_terms[key]
          }
        }
  
      }, 
      async clickOnGenerate(){
        this.progressCounter++
        if (this.reportSubType == 'Vendor + Product')
        {
          this.generateVendorProductReport()
        }
        else if (this.reportSubType == 'Product Category + Product')
        {
          this.generatProductCategoryProductReport()
        }
  
        this.progressCounter--
      },
  
      async generatProductCategoryProductReport()
      {
        this.progressCounter++
        let vendor_id = null
        if (this.vendor) {
            vendor_id=this.vendor.id;
        }
        let payload = {vendor_id:vendor_id, productcategory_id:this.productcategory_id, product_from: this.product_from, product_to: this.product_to, date_from:this.date_from, date_to:this.date_to };
        await axios.post(apiRoutes["REPORTS_PRODUCT_CATEGORY_PRODUCTS"], payload, authHeader()).then((response) => {
            if (response.data.code == 1) {
                this.report = response.data.data
            } else {
  
            }
  
            this.progressCounter--;
        })
        .catch((error) => {
            if (error.response) {
            console.log(error.response);
            Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
            });
            } else {
            console.log("Problem submitting New Post", error);
            }
        });
      },
      async generateVendorProductReport()
      {
        if(this.vendor==null)
        {
          this.vendor_id=null
        }
        else 
        {
          this.vendor_id=this.vendor.id
        }
        
        let payload = { vendor_id:this.vendor_id, product_id: this.product_id, date_from:this.date_from, date_to:this.date_to };
        await axios.post(apiRoutes["REPORTS_PURCHASE_PRICE_HISTORY"], payload, authHeader()).then((response) => {
            if (response.data.code == 1) {
                this.report = response.data.data
            } else {
  
            }
  
            this.progressCounter--;
        })
        .catch((error) => {
            if (error.response) {
            console.log(error.response);
            Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
            });
            } else {
            console.log("Problem submitting New Post", error);
            }
        });
      }
    }
  }
  </script>
  